import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, LayoutGrid, Brain, BookTemplate, User } from 'lucide-react';

const NAV_ITEMS = [
  { id: 'home', label: 'Home', icon: Home, path: '/dashboard' },
  { id: 'boards', label: 'Boards', icon: LayoutGrid, path: '/dashboard', matchAlso: ['/workspace', '/board'] },
  { id: 'ai', label: 'MrCanvas', icon: Brain, path: '/strategy-coach', isFab: true },
  { id: 'templates', label: 'Templates', icon: BookTemplate, path: '/templates' },
  { id: 'profile', label: 'Profile', icon: User, path: '/profile' },
];

export default function MobileBottomNav() {
  const location = useLocation();

  const isActive = (item) => {
    if (item.path === '/dashboard' && item.id === 'home') return location.pathname === '/dashboard' || location.pathname === '/';
    if (item.matchAlso) return item.matchAlso.some(p => location.pathname.startsWith(p));
    return location.pathname.startsWith(item.path);
  };

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      data-testid="mobile-bottom-nav"
    >
      <div className="mx-3 mb-2 rounded-2xl bg-background/80 backdrop-blur-xl border border-border shadow-2xl shadow-black/20">
        <div className="flex items-center justify-around h-16 px-1">
          {NAV_ITEMS.map(item => {
            const Icon = item.icon;
            const active = isActive(item);

            if (item.isFab) {
              return (
                <Link
                  key={item.id}
                  to={item.path}
                  className="relative -mt-6 flex flex-col items-center"
                  data-testid="mobile-nav-ai"
                >
                  <div className={`w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-all ${active ? 'bg-odapto-orange shadow-odapto-orange/30' : 'bg-odapto-orange/90 hover:bg-odapto-orange'}`}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <span className={`text-[10px] mt-1 font-medium ${active ? 'text-odapto-orange' : 'text-muted-foreground'}`}>
                    {item.label}
                  </span>
                </Link>
              );
            }

            return (
              <Link
                key={item.id}
                to={item.path}
                className="flex flex-col items-center justify-center gap-0.5 flex-1 py-2"
                data-testid={`mobile-nav-${item.id}`}
              >
                <Icon className={`w-5 h-5 transition-colors ${active ? 'text-odapto-orange' : 'text-muted-foreground'}`} />
                <span className={`text-[10px] font-medium transition-colors ${active ? 'text-odapto-orange' : 'text-muted-foreground'}`}>
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
